/**
 * Finds the enum wrapper object that matches the given enum value within the provided array.
 *
 * @param value an enum
 * @param allDtos the array of enum wrapper objects
 */
export const findEnumObject = <TEnum, TEnumDto extends { value: TEnum, text: string }>(
  value: TEnum, allDtos: TEnumDto[]) => allDtos.find((dto) => dto.value === value);

export const findEnumLabel = <TEnum, TEnumDto extends { value: TEnum, text: string }>(
  value: TEnum, allDtos: TEnumDto[]) => findEnumObject(value, allDtos)?.text;
